import type { ChangeEvent, FunctionComponent } from 'react';

import styles from './Toggle.less';

export const Toggle: FunctionComponent<{
  onChange: ((event: ChangeEvent<HTMLInputElement>) => void) | undefined;
  checked: boolean;
  label?: string;
}> = ({ onChange, checked, label }) => (
  <label className={styles.wrapper}>
    <span className={styles.switch}>
      <input
        aria-checked={checked}
        type="checkbox"
        onChange={onChange}
        checked={checked}
      />
      <span />
    </span>
    {label}
  </label>
);
